import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { PrimeIcons } from 'primeng/api';
import { Subject, takeUntil } from 'rxjs';
import { AgGridFn } from 'src/app/common/function-common/common';
import { toggleCustomGrid } from 'src/app/helpers/functions-common';
import { ApiService } from 'src/app/services/api.service';
const queryString = require('query-string');
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  private readonly unsubscribe$: Subject<void> = new Subject();
  data: any;
  showMore = false;
  events: any[];
  query = {
    filter: '',
    offSet: 0,
    pageSize: 10000,
    currentOrgId: ''
  };

  countRecord: any = {
    totalRecord: 0,
    currentRecordStart: 0,
    currentRecordEnd: 0
  }
  noRowsTemplate = `<span style="font-size: 20px">Không có kết quả</span>`;
  constructor(
    private apiService: ApiService,
    private changeDetector: ChangeDetectorRef,
    private spinner: NgxSpinnerService,
  ) { }
  ngOnInit(): void {
    this.fetchAssetChartData();
    this.fetchRecentAssets();
    this.load();
  }

  fetchAssetChartData () {
    this.apiService.getStatusPieChart()
    .subscribe((response: any) => {
      const data = response.data;
      this.data = {
        labels: data.labels,
        datasets: [
            {
                data: data.dataSets.data,
                backgroundColor: data.dataSets.backgroundColor,
                hoverBackgroundColor: data.dataSets.hoverBackgroundColor
            }
        ]
    };
    })
  }

  toggleCustomGrid(): void {
    toggleCustomGrid();
  }

  handleShowMore() {
    this.showMore = true
  }

  fetchRecentAssets() {
    this.apiService.getRecentlyCreatedPage()
    .subscribe((response: any) => {
      this.events = response.data.dataList
    })
  }
  loadjs = 0;
  heightGrid = 500
  heightGrid1 = 200
  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  columnDefs1 = [];
  listsData1 = [];
  columnDefs2 = [];
  listsData2 = [];
  columnDefs3 = [];
  listsData3 = [];
  columnDefs4 = [];
  listsData4 = [];
  gridflexs = [];
  allocate_grid = [];

  dataPage = null
  load() {
    this.columnDefs1 = []
    this.columnDefs2 = []
    this.columnDefs3 = []
    this.columnDefs4 = []
    this.spinner.show();
    const queryParams = queryString.stringify({...this.query});
    this.apiService.assetDashBoardGet(queryParams)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(results => {
        if (results.status === 'success') {
          this.listsData1 = results.data.category_dashboards ? results.data.category_dashboards : [];
          this.listsData2 = results.data.allocate_grid ? results.data.allocate_grid : [];
          this.listsData3 = results.data.failtures ? results.data.failtures : [];
          this.listsData4 = results.data.losts ? results.data.losts : [];
          this.allocate_grid =  results.data.allocate_grid
          if (this.query.offSet === 0) {
            this.dataPage = results.data;
          }
          this.onInitGrid1();
          this.onInitGrid2();
          this.onInitGrid3();
          this.onInitGrid4();
          this.countRecord.totalRecord = results.data.dataList;
          this.countRecord.currentRecordStart = this.query.offSet + 1;
          if ((results && results.data && results.data.dataList && results.data.recordsTotal - this.query.offSet) > this.query.pageSize) {
            this.countRecord.currentRecordEnd = this.query.offSet + Number(this.query.pageSize);
          } else {
            this.countRecord.currentRecordEnd = results.data.dataList;
          }
          this.spinner.hide();
        }
      })
  }

  onInitGrid1() {
    this.columnDefs1 = [
      ...AgGridFn(this.dataPage.view_category_dashboard_grid ? this.dataPage.view_category_dashboard_grid.filter((d: any) => !d.isHide): []),
      ];
  }
  onInitGrid2() {
    this.columnDefs2 = [
      ...AgGridFn(this.dataPage.view_allocate_grid ? this.dataPage.view_allocate_grid.filter((d: any) => !d.isHide): []),
      ];
  }
  onInitGrid3() {
    this.columnDefs3 = [
      ...AgGridFn(this.dataPage.view_failture_grid ? this.dataPage.view_failture_grid.filter((d: any) => !d.isHide): []),
      ];
  }
  onInitGrid4() {
    this.columnDefs4 = [
      ...AgGridFn(this.dataPage.view_lost_grid ? this.dataPage.view_lost_grid.filter((d: any) => !d.isHide): []),
      ];
  }
  first = 0
  paginate(event: any) {
    this.query.offSet = event.first
    this.first = event.first;
    this.query.pageSize = event.rows === 4 ? 100000000 : event.rows;
    this.load();
  }

}
